export default __webpack_public_path__ + "static/media/brand-zeus.9b15e882.jpg";